<template>
  <oceano-default-section :section="section" :menu="menu"
                          class="menu--section-oceano_dessert"></oceano-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Oceano dessert menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoDessertSection> adds a dessert layout for Oceano menu sections.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <OceanoDessertSection>.
 *    - Remove "visual_" prefix from class names in <OceanoDessertSection>.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoDessertSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-oceano_dessert:deep(.menu--item_subgroup) {
  grid-gap: 1.8em;
  margin-top: 1.8em;
}

.visual_menu--container-landscape .menu--section-oceano_dessert,
html .menu--section.menu--section-oceano_dessert {
  max-width: 564px;
}
.menu--section.menu--section-oceano_dessert {
  margin-left: auto;
  margin-right: auto;
  padding-left: 0;
  padding-right: 0;
}
</style>